const buildParams = (extraParams, page, pageSize, device_id) => ({
  page,
  page_size: pageSize,
  ...(extraParams.event_id && { event_id: extraParams.event_id }),
  ...(extraParams.start_date && { start_date: extraParams.start_date }),
  ...(extraParams.end_date && { end_date: extraParams.end_date }),
  ...(device_id && { device_id }),
  ...(extraParams.hasOwnProperty('show_transit') && { show_transit: extraParams.show_transit }),
});

export default buildParams;
